<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="enquestes">
    <ItemCommonDescription :data-card="dataCard.data[0]" :data-values="dataCard.value && dataCard.value[0]" @reload-data-card="reloadDataCard" />
    <div class="file-details-block has-side-bars">
      <ItemList :data-table="dataTable" />
    </div>
    <ItemViews :views="dataCard.data[0].popularity" />
    <ItemsRelated :card-id="dataCard.data[0].id" />
  </div>
</template>

<script>
import ItemCommonDescription from './ItemCommonDescription.vue'
import ItemList from './ItemList.vue'
import ItemViews from './ItemViews'
import ItemsRelated from './ItemsRelated'
import dayjs from 'dayjs'
/**
 * Enquestes view disposition
 * @example [none]
 */
export default {
  name: 'EnquestesItem',
  components: { ItemCommonDescription, ItemList, ItemViews, ItemsRelated },
  props: {
    /**
     * Item object information getted by api
     */
    dataCard: {
      type: Object,
    },
  },
  computed: {
    dataTable() {
      let enqTable = []
      if (this.dataCard.value) {
        if (this.dataCard.value[0]?.registry) {
          enqTable.push({
            name: this.dataCard.value[0].registryLabel,
            desc: this.dataCard.value[0].registry,
          })
        }
        if (this.dataCard.value[0]?.fieldStartDate && this.dataCard.value[0]?.fieldEndDate) {
          enqTable.push({
            name: this.dataCard.value[0].dateCompletionFieldWork,
            desc:
              this.dataCard.value[0].fieldStartDateLabel + ': ' +
              dayjs(this.dataCard.value[0].fieldStartDate).format('DD/MM/YYYY') +
              ' - ' +
              this.dataCard.value[0].fieldEndDateLabel + ': ' +
              dayjs(this.dataCard.value[0].fieldEndDate).format('DD/MM/YYYY'),
          })
        }
        if (this.dataCard.value[0]?.validationDate) {
          enqTable.push({
            name: this.dataCard.value[0].validationDateLabel,
            desc: dayjs(this.dataCard.value[0].validationDate).format('DD/MM/YYYY'),
          })
        }
        if (this.dataCard.value[0]?.size) {
          enqTable.push({
            name: this.dataCard.value[0].sizeLabel,
            desc: this.dataCard.value[0].size,
          })
        }
        if (this.dataCard.value[0]?.universe) {
          enqTable.push({
            name: this.dataCard.value[0].universeLabel,
            desc: this.dataCard.value[0].universe,
          })
        }
        if (this.dataCard.value[0]?.methodology) {
          enqTable.push({
            name: this.dataCard.value[0].methodologyLabel,
            desc: this.dataCard.value[0].methodology,
          })
        }
        if (this.dataCard.value[0]?.assignation) {
          enqTable.push({
            name: this.dataCard.value[0].assignationLabel,
            desc: this.dataCard.value[0].assignation,
          })
        }
        if (this.dataCard.value[0]?.ponderation) {
          enqTable.push({
            name: this.dataCard.value[0].ponderationLabel,
            desc: this.dataCard.value[0].ponderation,
          })
        }
        if (this.dataCard.value[0]?.process) {
          enqTable.push({
            name: this.dataCard.value[0].processLabel,
            desc: this.dataCard.value[0].process,
          })
        }
        if (this.dataCard.value[0]?.error) {
          enqTable.push({
            name: this.dataCard.value[0].errorLabel,
            desc: this.dataCard.value[0].error,
          })
        }
        if (this.dataCard.value[0]?.budget) {
          enqTable.push({
            name: this.dataCard.value[0].budgetLabel,
            desc: this.dataCard.value[0].budget,
          })
        }
        if (this.dataCard.value[0]?.company) {
          enqTable.push({
            name: this.dataCard.value[0].companyLabel,
            desc: this.dataCard.value[0].company,
          })
        }
        if (this.dataCard.value[0]?.allocation) {
          enqTable.push({
            name: this.dataCard.value[0].allocationLabel,
            desc: this.dataCard.value[0].allocation,
          })
        }
        if (this.dataCard.value[0]?.supporter) {
          enqTable.push({
            name: this.dataCard.value[0].supporterLabel,
            desc: this.dataCard.value[0].supporter,
          })
        }
        if (this.dataCard.value[0]?.typologyMustBeShown) {
          enqTable.push({
            name: this.dataCard.value[0].typologyLabel,
            desc: this.dataCard.value[0].typology,
          })
        }
        if (this.dataCard.value[0]?.dateQueryResultsMustBeShown) {
          enqTable.push({
            name: this.dataCard.value[0].dateQueryResultsLabel,
            desc: this.dataCard.value[0].dateQueryResults,
          })
        }
        if (this.dataCard.value[0]?.urlMustBeShown) {
          enqTable.push({
            name: this.dataCard.value[0].urlLabel,
            desc: this.dataCard.value[0].url.map(el => {
              return '<a href=' + el + '>' + el + '</a>'
            }).join('</br>'),
          })
        }
      }
      return enqTable
    },
  },
  methods: {
    reloadDataCard() {
      this.$emit('reload-data-card')
    },
  },
}
</script>

<style lang="stylus" scoped>
.enquestes
  display: flex
  flex-direction: column
  width: 100%
  gap: vw(10px)

  .file-details-block
    display: flex
    flex-direction: column
    padding-bottom: vw(25px)
    width: 100%
</style>
